<template>
    <div class="">
        <install-wizard-card>
            <template #top-header>User Creation</template>
            <template #top-content>Add as many users as you need; you can always add more users later!</template>

            <template #body-summary v-show="!hasLoadedAjax">
                <div class="bg-white px-4 py-5 sm:px-6">
                    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                        <div class="ml-4 mt-4">
                            <p class="text-md leading-6 font-medium text-gray-900">
                                Your site currently has {{numberOfUsersCreated}} user<span v-if="numberOfUsersCreated != 1">s</span>.
                            </p>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                            </p>
                        </div>
                        <div class="ml-4 mt-4 shrink-0">
                              <span class="inline-flex rounded-md shadow-sm">
                                  <a>
                                    <button type="button"
                                            @click="showUsers = !showUsers"
                                            class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-slate-600 hover:bg-slate-400 focus:outline-none focus:shadow-outline-neutral focus:border-neutral-700 active:bg-neutral-700">
                                        <div v-if="!showUsers">Show Users</div>
                                        <div v-else>Hide Users</div>
                                    </button>
                                  </a>
                              </span>
                        </div>
                    </div>
                </div>
                <div v-if="showUsers">
                    <ul class="list-disc pl-12">
                        <li v-for="user in users"
                                class="py-1">
                            <span class="">{{user.display_name}} </span>
                            <span   v-if="user.last_login"
                                    class="rounded-full text-sm font-medium px-2.5 py-0.5 leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                                Account Activated
                            </span>
                            <ul>
                                <li>
                                    <span class="text-sm text-grey-600">{{user.email}}</span>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </div>
            </template>

            <template #body-action>
                <div class="px-4 sm:px-12">
                    <user-add v-on:user-added="getUsersData($event)"></user-add>
                </div>
            </template>

            <template #bottom-header>Done adding users for now?</template>
<!--            <template #bottom-button-text></template>-->
        </install-wizard-card>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import axios from 'axios';
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import {isNull} from 'lodash';
    import _ from 'lodash'
    import UserAdd from "@/components/userAdd";

    export default {
        name: "InstallWizardUserCreation",
        props: {},
        mixins: [SonicuCoreMixin],
        data() {
            return {
                users: [],
                ajaxRoute: '',
                showUsers: false,
                waitingForCreatedUser: false,
            }
        },
        created() {
            this.getUsersData();
        },
        components: {UserAdd, InstallWizardCard},
        methods: {
            getUsersData(event){
                this.waitingForCreatedUser = (event === 'creating-user')
                this.reloadUsers();
            },
            reloadUsers() {
                axios.get(this.company.buildCompanyApiInternalRoute('wizard/users'))
                    .then((response) => {
                        let users = response.data.data
                        // If the new list of users is longer than the current list of users,
                        //   then we are done waiting for the user to be created
                        if (users.length > this.users.length) {
                            this.waitingForCreatedUser = false
                        }
                        this.users = response.data.data
                    });

                // If we are waiting for the user to be created, then check again in 2.5 seconds
                if (! this.waitingForCreatedUser) {
                    return
                }

                // Check for the users every 2.5 seconds
                setTimeout(() => {
                    this.reloadUsers();
                }, 2500)
            }
        },
        computed: {
            numberOfUsersCreated(){
                if(_.isNil(this.users)){
                    return 0;
                }
                return this.users.length;
            },
            hasLoadedAjax(){
                return _.isNil(this.users);
            }
        }
    }
</script>

<style scoped>

</style>